import { render, staticRenderFns } from "./OnboardingAcctDatatable.vue?vue&type=template&id=610cac7c&scoped=true&"
import script from "./OnboardingAcctDatatable.vue?vue&type=script&lang=js&"
export * from "./OnboardingAcctDatatable.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAcctDatatable.vue?vue&type=style&index=0&id=610cac7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610cac7c",
  null
  
)

export default component.exports